import { Pipe, PipeTransform } from '@angular/core';
import {MoedaPipe} from './moeda.pipe';

@Pipe({
	name: 'moedamilhar'
})
export class MoedaMilharPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		return value > 1000 ? this.toMilhar(value) : new MoedaPipe().transform(value, args);
	}
	toMilhar(value) {
		return  ((value - (value % 1000)) / 1000).toFixed(0) + 'K';
	}
}
